import React from 'react';
import styled from '@emotion/styled';
import {
  SegmentedViewLite,
  SegmentedViewControllerLite,
  SegmentedViewDataLite,
} from '../../../components/SegmentedView/SegmentedViewLite';
import ActiveJobs from './ActiveJobs/ActiveJobs';
import AllJobs from './AllJobs/AllJobs';

export const jobSegmentedControllerConfig = [
  { title: 'All Jobs' },
  { title: 'Active Jobs' },
];

const JobsSegment = () => {
  return (
    <Container>
      <SegmentedViewLite>
        <SegmentedViewControllerLite
          segmentedViewControllerTitle={jobSegmentedControllerConfig}
        />
        <SegmentedViewDataLite>
          <div>
            <AllJobs />
          </div>
          <div>
            <ActiveJobs />
          </div>
        </SegmentedViewDataLite>
      </SegmentedViewLite>
    </Container>
  );
};

export default JobsSegment;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
  width: 100%;
  border-radius: 10px;
  background: white;

  @media (max-width: 884px) {
    padding: 6px;
  }
`;
